/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$( document ).ready(function() {
  $('#feature-block-slider').slick({
    infinite: true,
    dots: false, 
	arrows: false,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });
  
  document.addEventListener('product:added', function(event) {
    addGiftItemToCart();
  });

  document.addEventListener('theme:loading:end', function(event) {
    checkAndRemoevGiftItem(event);       
  });
  
  document.addEventListener('variant:changed', function(event) {
    var formId = $(this).find('.ProductForm').attr('id');
   console.log(formId);
     $('.ProductForm .ProductForm__AddToCart').attr('type', 'button');
    $('.ProductForm .ProductForm__AddToCart').attr('onclick',"submitProdPageWithGift('"+formId+"')");

    $('.Collapsible__Content .variant-wise-faq').hide();
    $('.Collapsible__Content .variant-'+event.detail.variant.id+'-faq').show();
  });
  
  $('#sticky-varinat-seletion').on('change', function() {
    var imgSrc = $(this).find('option:selected').data('v-img');
    var availability = $(this).find('option:selected').data('avail');
    $(this).closest('.sticky-cart-container').find('.product-image img').attr('src', imgSrc);
    $(this).closest('.sticky-cart-container').find('.sticky-button-container .sticky-add-tocart').removeClass('disable-sticky-button');
    if(availability){
      $(this).closest('.sticky-cart-container').find('.sticky-button-container .sticky-add-tocart').text('AJOUTER AU PANIER');       
    }else{
      $(this).closest('.sticky-cart-container').find('.sticky-button-container .sticky-add-tocart').addClass('disable-sticky-button');
      $(this).closest('.sticky-cart-container').find('.sticky-button-container .sticky-add-tocart').text('RUPTURE DE STOCK');
    }

    var optionVal = $(this).find('option:selected').text();
    var formID = $(this).closest('#sticky-cart-container').find('#parentform_id').val();
    $('#'+formID+' .ColorSwatchList').find('input[type="radio"][value='+optionVal+']').next().click();
    
  });
  if($('#sticky-cart-container').length > 0){
    $(window).scroll(function(){
      
      var distance = $('.ProductForm__AddToCart').offset().top,
          $window = $(window);
      if($('.ProductForm__AddToCart').visible(true) == false && $window.scrollTop() >= distance){
        $('#sticky-cart-container').fadeIn();
      }else{
        $('#sticky-cart-container').fadeOut();
      }
    });
  }
 
});

function toggleAccordianPanale(elem){
  $('.about-us-container .accordinat-block').find('.accordion__item').removeClass('active');
  $(elem).closest('.accordion__item').addClass('active');
}

function toggleMobileAccord(elem){
  $(elem).closest('.el-item').toggleClass('uk-open');
}

function submitProdPageWithGift(id){
  $.ajax({
    type: 'POST',
    url: '/cart/add',
    data: $('#'+id).serialize(),
    dataType:'json',
    error: function()
    {
      console.log('error adding...')
    },
    success: function(response)
    {  
      addGiftItemToCart(false);
    } 
  });
  return false;
}


function submitProductFromSticky(elem){
  dt = {
    "quantity": 1,
    "id": $(elem).closest('.sticky-cart-wrapper').find('.sticky-product-option #sticky-varinat-seletion').val()
  }


  $.ajax({
    url: "../../../cart/add.js",
    data: dt,
    type : 'POST',
    dataType:'json',
    success: function(result){
      addGiftItemToCart(true);

    },
    error:function(result){
      console.log("Error");
    }
  });
}

function submitRelatedItem(elem){
  console.log("here");
  var dt;
  if($(elem).closest('.ProductItem__Wrapper').find('.ProductItem__ColorSwatchList').length > 0){
    dt = {
      "quantity": 1,
      "id": $(elem).closest('.ProductItem__Wrapper').find('.ProductItem__ColorSwatchList .ColorSwatch__Radio:checked').data('vid')
    }
  }else{
      dt = {
      "quantity": 1,
      "id": $(elem).data('defvid')
    }
  }
  


  $.ajax({
    url: "../../../cart/add.js",
    data: dt,
    type : 'POST',
    dataType:'json',
    success: function(result){
      //location.href = '/cart';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      })); 
      if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
      

      addGiftItemToWithColor(elem);

    },
    error:function(result){
      console.log("Error");
    }
  });
}

function checkAndRemoevGiftItem(event){

  if((typeof(event) != "undefined" && event.r_handle == 'mumexplorer-sac-a-langer' && event.r_quentity == 0 ) ||($('.Cart__ItemList .CartItem[data-handle="mumexplorer-sac-a-langer"]').length == 0)){
    var reload = false;
    if($('.Cart__ItemList .CartItem[data-handle="mumexplorer-sac-a-langer"]').length == 0){
      reload = true;
    }
    var giftPRodId0 = $('#gift-item-id-global-0').val();
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
        for(var i=0; i<result.items.length ; i++){
           if(result.items[i].product_id == giftPRodId0 && (((typeof(event) != "undefined" && result.items[i].options_with_values[0].value == event.r_color)) || $('.Cart__ItemList .CartItem[data-handle="mumexplorer-sac-a-langer"]').length == 0 )){
            var quantity =  0;
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + quantity + '&id=' + result.items[i].id,
              dataType: 'json',
              success: function(line_item) { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                })); 

                if(reload){
                  location.reload();
                }
               if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log("Error");
              }
            });
             break;
           }
            
        }
      },
      error:function(result){
        console.log("Error");
      }

    });
  }

  if((typeof(event) != "undefined" &&  event.r_handle == 'mumessential-sac-a-langer' && event.r_quentity == 0 )||($('.Cart__ItemList .CartItem[data-handle="mumessential-sac-a-langer"]').length == 0)){
    var giftPRodId1 = $('#gift-item-id-global-essential').val();
    var reload = false;
    if($('.Cart__ItemList .CartItem[data-handle="mumessential-sac-a-langer"]').length == 0){
      reload = true;
    }
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
        for(var i=0; i<result.items.length ; i++){
           if(result.items[i].product_id == giftPRodId1 && (((typeof(event) != "undefined" && result.items[i].options_with_values[0].value == event.r_color)) || $('.Cart__ItemList .CartItem[data-handle="mumessential-sac-a-langer"]').length == 0 ) ){
            var quantity =  0;
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + quantity + '&id=' + result.items[i].id,
              dataType: 'json',
              success: function(line_item) { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));  

                if(reload){
                  location.reload();
                }
               if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log("Error");
              }
            });
             break;
           }
            
        }
      },
      error:function(result){
        console.log("Error");
      }

    });
  }  


  if((typeof(event) != "undefined" &&  event.r_handle == 'mummoot-sac-a-langer' && event.r_quentity == 0 )||($('.Cart__ItemList .CartItem[data-handle="mummoot-sac-a-langer"]').length == 0)){
    var giftPRodId2 = $('#gift-item-id-gift_product_maternite').val();
    var reload = false;
    if($('.Cart__ItemList .CartItem[data-handle="mummoot-sac-a-langer"]').length == 0){
      reload = true;
    }
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
        for(var i=0; i<result.items.length ; i++){
           if(result.items[i].product_id == giftPRodId2 && (((typeof(event) != "undefined" && result.items[i].options_with_values[0].value == event.r_color)) || $('.Cart__ItemList .CartItem[data-handle="mummoot-sac-a-langer"]').length == 0 ) ){
            var quantity =  0;
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + quantity + '&id=' + result.items[i].id,
              dataType: 'json',
              success: function(line_item) { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));  

                if(reload){
                  location.reload();
                }
               if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log("Error");
              }
            });
             break;
           }
            
        }
      },
      error:function(result){
        console.log("Error");
      }

    });
  } 

  if((typeof(event) != "undefined" &&  event.r_handle == 'fluffyexplorer-sac-weekend-48h' && event.r_quentity == 0 )||($('.Cart__ItemList .CartItem[data-handle="fluffyexplorer-sac-weekend-48h"]').length == 0)){
    var giftPRodId3 = $('#gift-item-id-weekend').val();
    var reload = false;
    if($('.Cart__ItemList .CartItem[data-handle="fluffyexplorer-sac-weekend-48h"]').length == 0){
      reload = true;
    }
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
        for(var i=0; i<result.items.length ; i++){
           if(result.items[i].product_id == giftPRodId3 && (((typeof(event) != "undefined" && result.items[i].options_with_values[0].value == event.r_color)) || $('.Cart__ItemList .CartItem[data-handle="fluffyexplorer-sac-weekend-48h"]').length == 0 ) ){
            var quantity =  0;
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + quantity + '&id=' + result.items[i].id,
              dataType: 'json',
              success: function(line_item) { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));  

                if(reload){
                  location.reload();
                }
               if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log("Error");
              }
            });
             break;
           }
            
        }
      },
      error:function(result){
        console.log("Error");
      }

    });
  } 
}

function addGiftItemToCart(isSticky){
  
  if($('.ProductForm #gift-item-id').length > 0){
    var vid =$('.ProductForm #gift-item-id').val(); 
    
    var colorVidTitle  = '.ProductForm #gift-item-id-' + $('.ProductForm__Label .option_color').text().toLowerCase();
    if(isSticky){
      colorVidTitle  = '.ProductForm #gift-item-id-' + $('.sticky-cart-wrapper .sticky-product-option ').find('#sticky-varinat-seletion option:selected').text().toLowerCase();
    }
    if($(colorVidTitle).length > 0){
      vid =  $(colorVidTitle).val(); 
    }
    var giftEnable = true;
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
         console.log(result);
        for(var i=0; i<result.items.length ; i++){
          if(result.items[i].variant_id == vid){
            giftEnable= false;
            break;
          }
        }
            
        if(giftEnable){
          dt = {
            "quantity": 1,
            "id": vid,
      		"properties[Color]": $('.ProductForm__Label .option_color').text()
          }


          $.ajax({
            url: "../../../cart/add.js",
            data: dt,
            type : 'POST',
            dataType:'json',
            success: function(result){
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
              
            },
            error:function(result){
              console.log("Error");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              })); 
              if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
             
            }
          });
        }else{
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
             bubbles: true
          })); 
            if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
          
        }
        
      },
      error:function(result){
        console.log("Error");
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
        
      }

    });
    
    
    
    
  }else{
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    })); 
    
  }
}

function addGiftItemToWithColor(elem){

  var color = $(elem).data('title');
  
  if($(elem).closest('.Grid__Cell').find('.prod-gift-col-detail #gift-item-id').length > 0){
    var vid =$(elem).closest('.Grid__Cell').find('.prod-gift-col-detail #gift-item-id').val(); 

    console.log(vid);
    
    var colorVidTitle  = '.prod-gift-col-detail #gift-item-id-' + color.toLowerCase();
    
    if($(colorVidTitle).length > 0){
      vid =  $(colorVidTitle).val(); 
    }
    var giftEnable = true;
    $.ajax({
      url: "../../../cart.js",
      type : 'GET',
      dataType:'json',
      success: function(result){
         console.log(result);
        for(var i=0; i<result.items.length ; i++){
          if(result.items[i].variant_id == vid){
            giftEnable= false;
            break;
          }
        }
        
        
        
        if(giftEnable){
          dt = {
            "quantity": 1,
            "id": vid,
      		"properties[Color]": $('.ProductForm__Label .option_color').text()
          }


          $.ajax({
            url: "../../../cart/add.js",
            data: dt,
            type : 'POST',
            dataType:'json',
            success: function(result){
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
            },
            error:function(result){
              console.log("Error");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              })); 
              if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
            }
          });
        }else{
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
             bubbles: true
          })); 
          if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
        }
        
      },
      error:function(result){
        console.log("Error");
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        })); 
        if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
      }

    });
    
    
    
    
  }else{
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    })); 
    if($('#sidebar-cart').attr('aria-hidden') == true || $('#sidebar-cart').attr('aria-hidden') == 'true' ){
                  $('a[data-drawer-id="sidebar-cart"]')[0].click();
              }
  }
}

function toggleCartNot(){
  if($('.Cart__Footer #cart-note-input').is(':visible')){
    $('.Cart__Footer .cart-note-toggle').text("+");
    $('.Cart__Footer #cart-note-input').slideUp();
  }else{
    $('.Cart__Footer .cart-note-toggle').text("-");
    $('.Cart__Footer #cart-note-input').slideDown();    
  }
}

function  addwithBundelItem(id,vid) {
  $.ajax({
    type: 'POST',
    url: '/cart/add',
    data: $('#'+id).serialize(),
    error: function()
    {
      console.log('error adding...')
    },
    success: function(response)
    {  
      addBundleItem(vid);
    } 
  });
  return false;
}

function addBundleItem(vid) {

  var colorSelectec = $('.ProductForm__Label .option_color').text().toLowerCase();
  if($('.bundle-container #bundle-'+colorSelectec).length > 0){
    vid = $('.bundle-container #bundle-'+colorSelectec).val();
  }
  dt = {
    "quantity": 1,
    "id": vid
  }


  $.ajax({
    url: "../../../cart/add.js",
    data: dt,
    type : 'POST',
    dataType:'json',
    success: function(result){
      addGiftItemToCart(false);

    },
    error:function(result){
      console.log("Error");
    }
  });
}

function addUpsellItem(vid) {
  dt = {
    "quantity": 1,
    "id": vid
  }

  $.ajax({
    url: "../../../cart/add.js",
    data: dt,
    type : 'POST',
    dataType:'json',
    success: function(result){
      // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      //     bubbles: true
      //   })); 
        //location.href = '/cart';
      addGiftItemToCart(true);

    },
    error:function(result){
      console.log("Error");
    }
  });
}